import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Button from "./ui/Button";
import { cn, spacing, animations } from "../utils/cn";

const Contact = () => {
  const { t } = useTranslation();
  return (
    <section id="contact" className={cn("bg-navy", spacing.section)}>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
        <motion.div {...animations.fadeInUp}>
          {/* Section Number */}
          <p className="text-accent font-mono text-sm sm:text-base mb-4 sm:mb-5">
            <span className="text-accent font-mono mr-2">05.</span>
            {t('contact.subtitle')}
          </p>

          {/* Main Title */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-lighterSlate mb-4 sm:mb-5">
            {t('contact.title')}
          </h2>

          {/* Description */}
          <p className="text-base sm:text-lg text-slate leading-relaxed mb-8 sm:mb-10 lg:mb-12 max-w-lg mx-auto px-4">
            {t('contact.description')}
          </p>

          {/* CTA Button */}
          <Button
            href="mailto:anthony.roverenjeri@gmail.com"
            size="lg"
            magnetic={true}
          >
            {t('contact.cta')}
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
